import styled from '@emotion/styled';
import { COLOR_VARIANTS, color } from '@tajawal/ct-web-design-system';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
  background: ${color(COLOR_VARIANTS.BUTTERCUP10)};
  padding: 0px 8px;
  gap: 4px;
  border-radius: 4px;
  &:nth-child(2) {
    margin-top: 8px;
  }
`;

export default {
  Wrapper,
};
